<template>
  <div>
    <nav-menu/>
  </div>
</template>
<style>
</style>
<script>
import NavMenu from "./nav-menu.vue";

export default {
  components: {
    NavMenu
  },
  name: "HeaderComponent"
};
</script>
